import { Container , Grid } from "@material-ui/core";
import React from "react";
import ContactForm from "./contact-form";
import ContactDetails from "./contact-details";
import Breadcrumb from '../../components/Breadcrumb';
import GoogleMap from "./googlemap";
import translate from '../../translation.json';
import { lang } from "../../config/app.config";

const ContactUs:React.FC = ()=>{
  return(
    <>
    <Breadcrumb slug="contact-us" routes={[{title:translate.translation[lang].contact_us}]}/>
    <div className="text-center curveBackground">
      <h3 className="ecn-title-inv text-26">{translate.translation[lang].contact_us}</h3>
    </div>
    <Container maxWidth="lg" className="section-padding-2">
      <Grid container spacing={4}>
        <Grid item xs={12} md={6} lg={6}>
          <ContactDetails/>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <ContactForm/>
        </Grid>
      </Grid>
    </Container>
    <GoogleMap/>
    </>
  );
}

export default ContactUs;